var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BModal",
    {
      staticClass: "user-bulk-upload",
      attrs: { active: "" },
      on: { close: _vm.cancelModal }
    },
    [
      _c(
        "header",
        { staticClass: "modal-card-head" },
        [
          _c("p", { staticClass: "modal-card-title has-text-primary" }, [
            _vm._v("\n      Facturas\n    ")
          ]),
          _c("AppPagination", {
            staticClass: "is-centered",
            attrs: {
              "current-page": _vm.currentPage,
              "buttons-max": _vm.buttonsMax,
              "pages-total": _vm.totalPages
            },
            on: { change: _vm.goToPage }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-container" },
        [
          _c(
            "BTable",
            {
              attrs: {
                data: _vm.invoices,
                "checked-rows": _vm.checkedRows,
                columns: _vm.columns,
                "custom-is-checked": function(checkedRows, invoices) {
                  return checkedRows.id === invoices.id
                },
                checkable: ""
              },
              on: {
                "update:checkedRows": function($event) {
                  _vm.checkedRows = $event
                },
                "update:checked-rows": function($event) {
                  _vm.checkedRows = $event
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(props) {
                    return [
                      _c(
                        "BTableColumn",
                        {
                          attrs: {
                            field: "folio",
                            label: "Folio",
                            internal: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(props.row.folio) +
                              "\n        "
                          )
                        ]
                      ),
                      _c(
                        "BTableColumn",
                        {
                          attrs: { field: "uuid", label: "Uuid", internal: "" }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                props.row.cfdi.complement.digitalTaxStamp.uuid
                              ) +
                              "\n        "
                          )
                        ]
                      ),
                      _c(
                        "BTableColumn",
                        {
                          attrs: {
                            field: "total",
                            label: "Monto",
                            internal: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.voucherTotal(props.row.cfdi.voucherTotal)
                              ) +
                              "\n        "
                          )
                        ]
                      ),
                      _c(
                        "BTableColumn",
                        {
                          attrs: {
                            field: "moneda",
                            label: "Moneda",
                            internal: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(props.row.cfdi.voucherCurrency) +
                              "\n        "
                          )
                        ]
                      ),
                      _c(
                        "BTableColumn",
                        {
                          attrs: {
                            field: "receiverName",
                            label: "Nombre",
                            internal: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(props.row.cfdi.receiverName) +
                              "\n        "
                          )
                        ]
                      ),
                      _c(
                        "BTableColumn",
                        {
                          attrs: {
                            field: "fecha",
                            label: "Fecha",
                            internal: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm._f("toHumanDate")(props.row.cfdi.updatedAt)
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c("template", { slot: "empty" }, [
                _c("section", { staticClass: "section" }, [
                  _c(
                    "div",
                    { staticClass: "content has-text-grey has-text-centered" },
                    [
                      _c(
                        "p",
                        [
                          _c("BIcon", {
                            attrs: { icon: "emoticon-sad", size: "is-large" }
                          })
                        ],
                        1
                      ),
                      _c("p", [
                        _vm._v("Este cliente no cuenta con facturas PPD")
                      ])
                    ]
                  )
                ])
              ])
            ],
            2
          ),
          _c(
            "footer",
            { staticClass: "modal-card-foot" },
            [
              _c("p", { staticClass: "control" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-success",
                    attrs: { disabled: !_vm.checkedRows.length },
                    on: {
                      click: function($event) {
                        return _vm.closeModal(true)
                      }
                    }
                  },
                  [_vm._v("\n          Seleccionar\n        ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "button",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.closeModal(false)
                      }
                    }
                  },
                  [_vm._v("\n          Cerrar\n        ")]
                )
              ]),
              _c("AppPagination", {
                staticClass: "is-centered",
                attrs: {
                  "current-page": _vm.currentPage,
                  "buttons-max": _vm.buttonsMax,
                  "pages-total": _vm.totalPages
                },
                on: { change: _vm.goToPage }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }